import { getCookie, removeCookie, setCookie } from 'typescript-cookie';
import { ESession } from '../enums/auth.enum';

interface IWorkspaceCookies {
    workspaceID: string;
}

export const setWorkspaceCookies = ({ workspaceID }: IWorkspaceCookies) => {
    setCookie(ESession.WORKSPACE, workspaceID);
};

export const getWorkspaceCookies = () => ({
    workspaceID: getCookie(ESession.WORKSPACE),
});

export const removeWorkspaceCookies = () => {
    removeCookie(ESession.WORKSPACE);
};
